import { AppState } from "../../reducers";
import { DamageCostsState } from "./reducer";

export const damageCostsSelector = (state: AppState): DamageCostsState => {
  return state.damageCosts;
};
